import { render, staticRenderFns } from "./period-select.vue?vue&type=template&id=36f71b26&scoped=true"
import script from "./period-select.vue?vue&type=script&lang=js"
export * from "./period-select.vue?vue&type=script&lang=js"
import style0 from "./period-select.vue?vue&type=style&index=0&id=36f71b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f71b26",
  null
  
)

export default component.exports